/**
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from '../../../components/Containers/ArgosFlexbox';
import {Typography} from '@mui/material';


/**
 * Component that renders a static message when a model is not selected.
 */
const ModelNotSelected = () => {
  const notSelectedText = 'Select a model, version, and variation to view'

  return (
    <ArgosFlexbox style={{flexGrow: 1, flexDirection: 'column'}}>
      <Typography sx={{color: '#707071', fontSize: 20}}>
        {notSelectedText}
      </Typography>
    </ArgosFlexbox>
  )
}

export default ModelNotSelected
